import TopInfo from "./subs/TopInfo";
import MainHeaderNav from "./subs/MainHeader/MainHeader";
import ThemeSwitch from "./subs/ThemeSwitch";

const Header = () => {
  return (
    <>
      <header className="rbt-header rbt-header-9">
        <div className="rbt-sticky-placeholder"></div>
        <TopInfo />
        <MainHeaderNav />
      </header>
      <ThemeSwitch />
    </>
  );
};
export default Header;
